import type { ComponentProps } from 'react';

import { Position } from '#src/__generated__/globalTypes.ts';
import { BasketballCenter } from '#src/assets/icons/BasketballCenter.tsx';
import { BasketballForward } from '#src/assets/icons/BasketballForward.tsx';
import { BasketballGuard } from '#src/assets/icons/BasketballGuard.tsx';
import { DefaultPosition } from '#src/assets/icons/DefaultPosition.tsx';
import { Glove } from '#src/assets/icons/Glove.tsx';
import { Jersey } from '#src/assets/icons/Jersey.tsx';
import { Shield } from '#src/assets/icons/Shield.tsx';
import { Shoe } from '#src/assets/icons/Shoe.tsx';

const iconPerPosition: Record<
  | typeof Position.Goalkeeper
  | typeof Position.Defender
  | typeof Position.Midfielder
  | typeof Position.Forward
  | typeof Position.basketball_center
  | typeof Position.basketball_forward
  | typeof Position.basketball_guard,
  | typeof Glove
  | typeof Shield
  | typeof Jersey
  | typeof Shoe
  | typeof BasketballCenter
  | typeof BasketballForward
  | typeof BasketballGuard
> = {
  // FOOTBALL
  [Position.Goalkeeper]: Glove,
  [Position.Defender]: Shield,
  [Position.Midfielder]: Jersey,
  [Position.Forward]: Shoe,

  // NBA
  [Position.basketball_center]: BasketballCenter,
  [Position.basketball_forward]: BasketballForward,
  [Position.basketball_guard]: BasketballGuard,
};

type Props = { position: Nullable<Position | string> } & ComponentProps<
  typeof Glove
> &
  ComponentProps<typeof Shield> &
  ComponentProps<typeof Shoe> &
  ComponentProps<typeof Jersey> &
  ComponentProps<typeof BasketballCenter> &
  ComponentProps<typeof BasketballForward> &
  ComponentProps<typeof BasketballGuard> &
  ComponentProps<typeof DefaultPosition>;

export const PositionIcon = ({ position, size, hollow, ...rest }: Props) => {
  const Icon =
    position && position in iconPerPosition
      ? iconPerPosition[position as keyof typeof iconPerPosition]
      : DefaultPosition;

  return <Icon size={size} hollow={hollow} {...rest} />;
};
